<template>
  <div
    style="
      color: #868686;
      width: 100%;
      border: 8px solid #f8fafc;
      border-radius: 6px;
      padding: 10px;
      line-height: 20px;
    "
  >
    <el-icon class="el-icon-warning-outline"></el-icon>
    <span> {{ item.options }}</span>
  </div>
</template>

<script>
import Minxins from "../Minxins";
export default {
  name: "Description",
  mixins: [Minxins],
};
</script>

<style scoped>
</style>
